// @core/api/endpoints/document/list_categories.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListCategoriesResponse,
} from '../../../types/document';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/document';

/**
 * List categories
 * Returns document categories. Can return flat list or hierarchical tree.
 */
export async function ListCategories(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListCategoriesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/document-categories`;
  const requestOptions = options;
  return client.get<ListCategoriesResponse>(requestPath, { ...requestOptions, params });
}
